import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form"]
  
  connect() {
    this.handleChange = this.handleChange.bind(this)
    this.formTargets.forEach((form) => {
      form.addEventListener("change", this.handleChange)
    })
  }

  disconnect() {
    this.formTargets.forEach((form) => {
      form.removeEventListener("change", this.handleChange)
    })
  }

  handleChange(event) {
    if (event.target.type === "checkbox" || event.target.tagName === "SELECT") {
      const form = event.target.closest("form")
      if (form) form.requestSubmit()
    }
  }
}